__turbopack_context__.v({
  "root": "verticalNavBgImage-module__nBlmca__root",
});
